export enum PERM_CODES {
  PG_VIEW = 100,
  PG_SUMMARY_VIEW = 1500,
  PG_ORDERS_VIEW = 1000,
  PG_TRANSACTIONS_VIEW = 1300,
  PG_REFUNDS_VIEW = 1350,
  PG_DISPUTES_VIEW = 1360,
  PG_SETTLEMENTS_VIEW = 1330,
  PG_OFFERS_VIEW = 1550,
  PG_PAYMENTLINK_VIEW = 1600,
  PG_PAYMENTFORM_VIEW = 1900,
  PG_DEVELOPERS_VIEW = 1430,
  PG_ACCESSNOTIFICATIONS_VIEW = 1420,
  PG_CHECKOUTPREFERENCES_VIEW = 1400,
  PG_PAYMENTMETHODS_VIEW = 1700,
  PG_ALLTRANSACTIONS_VIEW = 13001,
  PG_ALL_LINKS_VIEW = 16003,
  PG_PAYMENTFORM_WRITE = 19001,
  PG_ALLCHECKOUTPREFERENCES_VIEW = 14001,
  PG_ALLCHECKOUTPREFERENCES_UPDATE = 14002,
  PG_ALLPAYMENTMETHODS_VIEW = 17001,
  PG_APIKEY_VIEW = 14301,
  PG_SOFTPOS_AGENTMANAGEMENT = 18001,
  PG_SFTP_CONFIGURATION_VIEW = 1910,
  PG_SFTP_CONFIGURATION_SETUP = 19101,
  PG_SCHEDULE_REPORTS_VIEW = 1911,
  PG_SCHEDULE_REPORTS_CREATE = 19111,
  FLOWWISE_VIEW = 700,
  FLOWWISE_GATEWAY_VIEW = 710,
  FLOWWISE_GATEWAY_WRITE = 730,
  FLOWWISE_CONFIGURATION_VIEW = 740,
  FLOWWISE_CONFIGURATION_WRITE = 750,
}
